import product from "./product";

export default {
    product,

    noAvailableItems: "Aucun produit disponible à la commande."
}